// @flow
import * as Cookie from 'app/packages/cookie-utils';
import app from 'app/common/lib/app';
import context from 'app/common/lib/context';
import getOrSetVisitCookie from 'app/common/lib/getOrSetVisitCookie';
import onDOMContentLoaded from 'app/common/lib/onDOMContentLoaded';
import store from 'app/common/redux/store/singleton';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import urlUtil from 'app/common/lib/urlUtil';
import user from 'app/common/lib/User';
import logStats, { getSampleRate } from 'app/common/lib/logStats';

const LogTraffic = {
  getAppTypeString() {
    return 'desktop';
  },

  getReferrer() {
    const queryString = window.location.search.substr(1); // strip leading ?
    const queryParams = urlUtil.getQueryStringParams(queryString);
    if (queryParams.utm_source === '31') {
      return 'email';
    } else if (queryParams.utm_pai) {
      return 'paid';
    }

    const referrer_url = Cookie.get(PCONST.COOKIE_SESSION_REFERRER) || document.referrer;
    if (!referrer_url) {
      return 'direct';
    } else if (referrer_url.indexOf('/t.co/') > -1) {
      return 'twitter';
    } else if (referrer_url.indexOf('google.') > -1) {
      return 'google';
    } else if (referrer_url.indexOf('bing.') > -1) {
      return 'bing';
    } else if (referrer_url.indexOf('facebook.') > -1) {
      return 'facebook';
    } else {
      return 'other';
    }
  },

  getBotType() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent) {
      if (
        userAgent.indexOf('googlebot') > -1 ||
        userAgent.indexOf('google web preview') > -1 ||
        userAgent.indexOf('google page speed insights') > -1
      ) {
        return 'google_bot';
      } else if (userAgent.indexOf('msnbot') > -1 || userAgent.indexOf('bingbot') > -1) {
        return 'ms_bot';
      } else if (userAgent.indexOf('applebot') > -1) {
        return 'apple_bot';
      } else if (userAgent.indexOf('yahoo') > -1 || userAgent.indexOf('slurp') > -1) {
        return 'yahoo_bot';
      } else if (userAgent.indexOf('yandex') > -1) {
        return 'yandex';
      }
    }

    return undefined;
  },

  getModuleName() {
    if (app.instance) {
      return app.instance.initModule.className;
    } else if (store && store.instance) {
      return store.instance.getState().ui.mainComponent.initial;
    } else {
      return '';
    }
  },

  logTrafficRegisterOnLoad() {
    if (!__SERVER__) {
      onDOMContentLoaded(() => this.logTraffic());
    }
  },

  logTraffic() {
    const appTypeString = this.getAppTypeString(context);
    const botType = this.getBotType();
    const firstVisit = getOrSetVisitCookie();
    const moduleName = this.getModuleName();
    const referrer = this.getReferrer();
    const isAuth = user.isAuthenticated() ? 'auth' : 'unauth';
    const subdomain = document.domain || 'unknown';
    const stage = context.initialPageContext && context.initialPageContext.stage;

    if (firstVisit) {
      trackRegisterAction(`traffic.${appTypeString}.${referrer}.${moduleName}.${isAuth}`);
      trackRegisterAction(`traffic_subdomain.${subdomain}.${referrer}.${moduleName}.${isAuth}`);
      trackRegisterAction(
        `traffic_subdomain.${subdomain}.${appTypeString}.${referrer}.${moduleName}.${isAuth}`,
      );
      trackRegisterAction(`traffic_subdomain.${subdomain}.${appTypeString}.${isAuth}`);
      if (botType) {
        trackRegisterAction(`traffic_bot.${botType}.${moduleName}`);
      }
    }

    logStats.increment('webapp.traffic', getSampleRate(0.1), {
      domain: subdomain,
      userAgentPlatform: appTypeString,
      pageType: 'web',
      botType,
      firstVisit,
      isAuth,
      moduleName,
      referrer,
      stage,
    });
  },
};

export default LogTraffic;
